export const imageUrlKey = 'image_link';
export const colorsPaletteKey = 'Color Palette';
export const earlyCloseConditionKey = 'early_close_condition';
export const contractTickerKey = 'contract_ticker';
export const separatorTypeKeys = ['above/below/between', 'above/below'] as const;
export const capStrikeKey = 'Cap_strike';
export const floorStrikeKey = 'Floor_strike';
export const countKey = 'Count';
